module.exports = __webpack_public_path__ + "static/media/14.8e0007d1.jpg";